import { IAssignedBPPlanInfo } from '.';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues: IAssignedBPPlanInfo = {
  businessPartner: '',
  line: '',
  plan: [],
};

export const drawerSections = (
  values: IAssignedBPPlanInfo = initialValues,
  lovs: Record<string, Record<string, string>>
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      businessPartner: {
        name: 'businessPartner',
        title: 'Business Partner',
        type: FormFieldType.select,
        placeholder: 'Business Partner',
        value: !isEmpty(values.businessPartner) ? values.businessPartner : '',
        required: true,
        selectOptions: lovs.primaryBP || {},
      },
      line: {
        name: 'line',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: !isEmpty(values.line) ? values.line : '',
        required: true,
        selectOptions: lovs.line || {},
      },
      plan: {
        name: 'plan',
        title: 'Plan',
        type: FormFieldType.multiSelect,
        placeholder: 'Plan',
        value: !isEmpty(values.plan) ? values.plan : [],
        required: true,
        selectOptions: lovs.plan || {},
      },
    },
  },
];
